export enum SubscriptionNotifyType {
	EXPIRED = 'expired',
	EXPIRE_SOON = 'expire_soon',
}
